import ContainerChart from "../../../Component/Widgets/Charts/Chart"

const Charts = () => {
  return (
    <div className='page-body'>
      <ContainerChart />
    </div>
  )
}

export default Charts